import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const RIGHT_EDGE_RAIL_SLOT_ID = 'right-edge-rail-slot';

/** Hängt Seiten-Laschen (z. B. Übersicht) in die gemeinsame rechte Leiste unter Light/Premium. */
const RightEdgeRailSlot: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [target, setTarget] = useState<HTMLElement | null>(null);

    useEffect(() => {
        const find = () => document.getElementById(RIGHT_EDGE_RAIL_SLOT_ID);
        const existing = find();
        if (existing) {
            setTarget(existing);
            return;
        }
        const timer = window.setInterval(() => {
            const el = find();
            if (el) {
                setTarget(el);
                window.clearInterval(timer);
            }
        }, 50);
        return () => window.clearInterval(timer);
    }, []);

    if (!target) return null;
    return createPortal(children, target);
};

export default RightEdgeRailSlot;
